/**
 * @title quick-application.js: Feature level module
 * @description The interface for quick membership application. These methods
 *              are bound in /QuickMembershipApplicationView
 *              (QuickMembershipApplicationBody.jsp) and use applicationForm
 *              for primary membership interaction and applicationAffiliateForm
 *              for affiliate interaction.
 */
define(['application', 'logon', 'registerUser'], function(Application, Logon, RegisterUser) {
  let QuickApplication = {
    /**
     * Initialize the application specific functions
     * @return {void}
     */
    init: function() {
      Application.init();
      COSTCO.MembershipHelper.isQuickMembership = true;

      if (this.isAccountBlockDisplayed()) {
        this.displayAccountMembershipForm();
      }
      this.bindEvents();
      this.showOptionalSections();
      $('#MemberAddressBookForm').keypress(function (e) {
          if (e.which == 13) {
        	  QuickApplication.saveContinue()
          }
        });
    },
    isAccountBlockDisplayed: function() {
      return $('#account-membership-block').length > 0;
    },
    /**
     * If there is data, expand People within Household and Additional People sections on page load.
     * @return {void}
     */
    showOptionalSections: function() {
      if ($('#household_first_name').val()) {
        $('#household-body').collapse('show');
      }
      if ($('.affiliate-block').length > 0) {
        $('#additional-people-body').collapse('show');
      }
    },
    /**
     * Bind event handlers for membership application page
     */
    bindEvents: function() {
      // Copy content of email field in primary membership block to account section of the page
      $('#email').blur(function() {
        if ($('#register_email1').length > 0 && (Boolean($('#register_email1').val()) == false)) {
          $('#register_email1').val(this.value);
        } else if (Boolean($('#logonId').val()) == false) {
          $('#logonId').val(this.value);
        }
      });

      $('#set-default').click(function() {
        if ($(this).prop('checked')) {
          $('#save-address').prop('checked', true);
          $('.defaultWarning.kb-OOS-banner').removeClass('hide');
        } else {
          $('.defaultWarning.kb-OOS-banner').addClass('hide');
        }
      });
      $('#save-address').click(function() {
        if (!$(this).prop('checked')) {
          $('#set-default').prop('checked', false);
        }
      });
    },
    /**
     * Submit Membership Application via Save&Continue button.
     * @return {void}
     */
    submitApplication: function(addresses) {
      let isAppFormValid = COSTCO.ApplicationForm.validate();
      if ($('#LogonForm').length > 0) {
        // Try to log the user in, and then submit the MemberApplication form
        let isLogonFormValid = $('#LogonForm').valid();
        if (isLogonFormValid && isAppFormValid) {
          $('.permanent-ajax-busy').addClass('ajax-busy');
          COSTCO.util.ajax({
            type: 'POST',
            url: '/AjaxLogon',
            dataType: 'json',
            data: $('#LogonForm').serializeArray(),
            done: function(data, textStatus, jqXHR, options) {
              if (data.errorMessage) {
                $('.permanent-ajax-busy').removeClass('ajax-busy');
                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.errorMessage], true, '#account-error');
              } else {
                COSTCO.util.notification.clearNotification('#account-error');
                COSTCO.ApplicationForm.submitContinue(addresses);
              }
            },
            fail: function(data, textStatus, jqXHR, options) {
              $('.permanent-ajax-busy').removeClass('ajax-busy');
              console.log('Ajax call failed!');
            },
            always: function() {},
          });
        } else {
          $('.permanent-ajax-busy').removeClass('ajax-busy');
        }
      } else if ($('#RegisterForm').length > 0) {
        // Try to register the user first, and then submit the MemberApplication form
        let isRegisterFormValid = $('#RegisterForm').valid();
        if (isAppFormValid && isRegisterFormValid) {
          $('.permanent-ajax-busy').addClass('ajax-busy');
          COSTCO.util.ajax({
            type: 'POST',
            url: '/AjaxUserRegistrationAdd',
            dataType: 'json',
            data: $('#RegisterForm').serializeArray(),
            done: function(data, textStatus, jqXHR, options) {
              if (data.errorMessage) {
                $('.permanent-ajax-busy').removeClass('ajax-busy');
                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.errorMessage], true, '#account-error');
              } else {
                COSTCO.util.notification.clearNotification('#account-error');
                COSTCO.ApplicationForm.submitContinue(addresses);
              }
            },
            fail: function(data, textStatus, jqXHR, options) {
              $('.permanent-ajax-busy').removeClass('ajax-busy');
              console.log('Ajax call failed!');
            },
            always: function() {},
          });
        } else {
          $('.permanent-ajax-busy').removeClass('ajax-busy');
        }
      } else {
        if (isAppFormValid) {
          $('.permanent-ajax-busy').addClass('ajax-busy');
          COSTCO.ApplicationForm.submitContinue(addresses);
        } else {
          $('.permanent-ajax-busy').removeClass('ajax-busy');
        }
      }
    },
    /**
     * Main function and inline event handler for "Save and Continue"
     * for adding personal information / business information to the
     * application.
     * @return {void} [description]
     */
    saveContinue: function() {
      if (COSTCO.ApplicationForm.validate() && COSTCO.QuickApplication.passwordMatch() ) {
    	  $('#MemberAddressBookForm').find('input[id="addressEnteredForCheck"]').remove();
    	  $('#MemberAddressBookForm').append('<input type="hidden" id="addressEnteredForCheck" value="'+$('#address1').val()+'"/>'); 
    	// Pages using this: QuickMembershipApplicationBody.jsp,
        COSTCO.MembershipHelper
          // Attempt to call address verification service
          .verifyAddresses({
            form: '#MemberAddressBookForm',
            primary: COSTCO.MembershipHelper.personalAddressSelectors,
            business: COSTCO.MembershipHelper.businessAddressSelectors,
          })
          // If the service returns successfully (200), invoke the modal
          // and use the addresses the user selects
          .then((verifyResponse) =>
            COSTCO.MembershipHelper.invokeMultiAVS(verifyResponse, QuickApplication.submitApplication))
          // If the service fails, we still want to submit the form using
          // the addresses the user provided initially
          .fail(QuickApplication.submitApplication);
      }
    },
    
    passwordMatch: function() {
      let equals = false;
      if($('#alreadyHaveAccount:checkbox:checked').length > 0) {
    	  equals = true;
      } else if($('#logonPassword').length === 0 && $('#logonPasswordVerify').length === 0 ) {
    	  equals = true;
      } else if ($('#logonPasswordVerify').length > 0 && $('#logonPassword').length > 0) {
	        equals = $('#logonPasswordVerify').val() === $('#logonPassword').val();
      }
      return equals;
    },
    /**
     * Displays a register or logon form depending of user selected "I already have a Costco.com account" checkbox
     */
    displayAccountMembershipForm: function() {
      if ($('#alreadyHaveAccount').prop('checked')) {
        $('#account-membership-block').html(COSTCO.util.tmpl('tmpl_logon_membership', {
          emailValue: $('#email').val(),
        }));
        Logon.init();
      } else {
        $('#account-membership-block').html(COSTCO.util.tmpl('tmpl_register_membership', {
          emailValue: $('#email').val(),
        }));
        RegisterUser.init();
      }
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.QuickApplication = QuickApplication;
  return QuickApplication;
});



// WEBPACK FOOTER //
// ./js/membership/quick-application.js